import type { ReceiptExtractedPayload } from "@project/core";
import type { ExpenseCategory } from "@apps/dashboard/lib/home-expense-types";

export function matchCategoryId(
  categories: ExpenseCategory[],
  payload: ReceiptExtractedPayload,
): string {
  const slug = payload.suggestedCategorySlug?.toLowerCase().trim();
  if (slug) {
    const bySlug = categories.find((c) => c.slug?.toLowerCase() === slug);
    if (bySlug) return bySlug.id;
  }
  const name = payload.suggestedCategoryName?.trim().toLowerCase();
  if (name) {
    const byName = categories.find((c) => c.name.trim().toLowerCase() === name);
    if (byName) return byName.id;
  }
  return "";
}

export function notesFromExtraction(payload: ReceiptExtractedPayload): string {
  const parts: string[] = [];
  if (payload.notes?.trim()) {
    parts.push(payload.notes.trim());
  }
  if (payload.lineItems?.length) {
    const lines = payload.lineItems.map((l) => l.description).filter(Boolean);
    if (lines.length) {
      parts.push(lines.join("; "));
    }
  }
  return parts.join("\n");
}
